import { FormattedMessage } from "react-intl";
import ConfirmModal from "../../../../../components/confirm-modal";
import messages from "../../../../ProductSettings/messages";

type ConfirmDeleteProps = {
  onClose: () => void;
  onDelete: () => void;
  visible: boolean;
  deleting?: boolean;
};

export const ConfirmDelete = (props: ConfirmDeleteProps) => {
  const { onClose, onDelete, deleting, visible } = props;

  return (
    <ConfirmModal
      title={<FormattedMessage {...messages.deleteWarningTitle} />}
      leftButtonOnClick={onClose}
      rightButtonOnClick={onDelete}
      leftButtonText={<FormattedMessage {...messages.deleteWarningDontDelete} />}
      rightButtonText={<FormattedMessage {...messages.deleteWarningDelete} />}
      close={onClose}
      loading={deleting}
      visible={visible}
    >
      <FormattedMessage {...messages.deleteWarningMessage} />
    </ConfirmModal>
  );
};
